import styled from "styled-components";

export const ModalContainer = styled.div`
    display: ${({$Active})=> ($Active ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    position: fixed;
    background: rgba(80, 80, 80, 0.7);
    transition: ease-out 0.8s;
    width: 100%;
    height: 100vh;
    z-index: 9999;
`;

export const ContentContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #fff;
    height: fit-content;
    border-radius: 20px;
    padding: 25px;
    max-height: 50%;
`;

export const TitleContainer = styled.h3`
    color: #333;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ChildsContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-block: 20px;
    gap: 10px;
    height: 100%;
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
        width : 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 90%;
    padding-block: 25px;
`;

export const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-block: 10px;
    padding-inline: 20px;
    gap: 8px;
    background: ${({$background})=> $background};
    color: ${({$color})=> $color};
    border-radius: 10px;
    cursor: pointer;
    border: ${({$border})=> $border ? $border : 'none'};
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    font-size: 15.113px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    &:hover {
        background: ${({$hoverBackgroundColor})=> $hoverBackgroundColor};
        color: ${({$hoverTextColor})=> $hoverTextColor};
    }
`;